<template>
  <div class="wrapper-auth" v-if="$router.currentRoute.query.token">
    <el-container class="new-password my-5">
      <h2 class="text-center text-white">IDC Online Cloud Portal</h2>
      <div id="form-new-password" class="mt-3 mb-2 py-2 px-3">
        <h3 class="text-center">{{$t('auth.resetPassword.title')}}</h3>
        <el-form :model="ruleForm" :rules="rules" ref="formResetPassword" class="pt-3">
          <el-form-item prop="password">
            <el-input type="password" v-model="ruleForm.password" autocomplete="off" :placeholder="$t('auth.resetPassword.password.placeholder')"></el-input>
          </el-form-item>
          <el-form-item prop="confirmPassword">
            <el-input type="password" v-model="ruleForm.confirmPassword" autocomplete="off" :placeholder="$t('auth.resetPassword.passwordConfirm.placeholder')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="w-100"
                       :disabled="isResetPassword"
                       @click="!isResetPassword ? handleResetPassword(ruleForm) : null">
              {{$t('auth.resetPassword.btn')}}  <i class="el-icon-loading" v-if="isResetPassword"></i>
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-container>
    <img-auth></img-auth>
  </div>
</template>

<script>
  import ImgAuth from './components/img-auth'
  import authServices from '@/services/auth'
  export default {
    components: {
      'img-auth': ImgAuth
    },
    data () {
      const validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('auth.resetPassword.password.required')))
        } else {
          if (this.ruleForm.confirmPassword !== '') {
            this.$refs.formResetPassword.validateField('confirmPassword')
          }
          callback()
        }
      }
      const validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('auth.resetPassword.passwordConfirm.required')))
        } else if (value !== this.ruleForm.password) {
          callback(new Error(this.$t('auth.resetPassword.passwordConfirm.notmatch')))
        } else {
          callback()
        }
      }
      return {
        isResetPassword: false,
        ruleForm: {
          password: '',
          confirmPassword: ''
        },
        rules: {
          password: [
            { validator: validatePass, trigger: ['blur', 'change'] }
          ],
          confirmPassword: [
            { validator: validatePass2, trigger: ['blur', 'change'] }
          ]
        }
      }
    },
    methods: {
      checkHasToken () {
        if (!this.$router.currentRoute.query.token) {
          this.$router.push({name: 'login'})
        }
      },
      handleResetPassword (form) {
        this.$refs.formResetPassword.validate((valid) => {
          if (valid) {
            this.isResetPassword = true
            authServices.resetPassword({token: this.$router.currentRoute.query.token, new_password: form.password})
              .then(res => {
                this.isResetPassword = false
                this.$notify.success({
                  message: this.$t('notify.success.resetPassword'),
                  showClose: false,
                  duration: 3000
                })
                this.$router.push({name: 'login'})
              })
              .catch(e => {
                console.log(e)
                let msg = ''
                if (e.response.data && e.response.data.message) {
                  msg = e.response.data.message
                }
                this.isResetPassword = false
                this.$notify({
                  message: msg,
                  showClose: false,
                  duration: 3000,
                  customClass: 'error'
                })
              })
          }
        })
      }
    },
    mounted () {
      this.checkHasToken()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/auth/reset-password.vue